import { styled } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

export const CenteredRow = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  padding: '1rem'
})
